'use strict';

var IdGenerator = require('./generator');
var generator;

exports = module.exports = function generateAutoId (now) {
  if (!generator) generator = new IdGenerator()
  return generator.generate(now);
};

exports.Generator = IdGenerator;



//////////////////
// WEBPACK FOOTER
// ./~/firebase-auto-ids/src/index.js
// module id = ./node_modules/firebase-auto-ids/src/index.js
// module chunks = 0